"use client";
import "../../chunk-MMUBH76A.js";
import { useModalStore } from "../stores/index.js";
import { openPopup } from "../utils/openPopup.js";
import { ModalStep } from "../utils/steps.js";
function useCreateAccount() {
  const refs = useModalStore((state) => state.refs);
  const setStep = useModalStore((state) => state.setStep);
  const webAuthURLForCreate = useModalStore((state) => state.webAuthURLForCreate);
  return {
    withPasskey: () => {
      var _a;
      if (((_a = refs.poll.current) == null ? void 0 : _a.action) !== "signup") {
        return;
      }
      refs.popupWindow.current = openPopup({
        url: webAuthURLForCreate,
        target: "ParaPasskey",
        type: "CREATE_PASSKEY",
        current: refs.popupWindow.current
      });
      if (refs.currentStep.current !== ModalStep.AWAITING_BIOMETRIC_CREATION) {
        setStep(ModalStep.AWAITING_BIOMETRIC_CREATION);
      }
    },
    withPassword: () => {
      var _a;
      if (((_a = refs.poll.current) == null ? void 0 : _a.action) !== "signup") {
        return;
      }
      if (refs.currentStep.current !== ModalStep.PASSWORD_CREATION) {
        setStep(ModalStep.PASSWORD_CREATION);
      }
    }
  };
}
export {
  useCreateAccount
};
